import 'project/css/main.css';
import { Mediator } from 'project/modules/mediator/mediator';
import packageJson from 'root/package.json';

document.addEventListener('DOMContentLoaded', (event) => {
	window.version = '?' + packageJson.version;
	new Mediator().init();
});